import FlightDetails from './FlightDetails';
import getValidationSchema from './components/DriverInfoGrid/schema';
import transportSchema from './components/TransportInfoGrid/schema';

export { getValidationSchema, transportSchema };

export default FlightDetails;
